/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React from 'react';

import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { ToastProvider } from '@forge/common';
import { withLDProvider } from 'launchdarkly-react-client-sdk';

import App from './App';

import store from './store'; // Import the store

import './i18n'; // Import the i18n configuration

import { ConfigurationVariables } from './config';

import './index.scss';
import "./styles/global.scss";

const LDProvider = withLDProvider({
	clientSideID: ConfigurationVariables.LAUNCH_DARKLEY_CLIENT_ID
})(App);

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
	<Provider store={store}>
		<ToastProvider>
			<LDProvider />
		</ToastProvider>
	</Provider>
);